import { createAsyncThunk } from '@reduxjs/toolkit';
import { FeedsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { FEEDS_SLICE_NAME } from './models';
import {
  IGetFeedsDTO,
  IGetFeedsResponse,
  IGetFeedDTO,
  IGetFeedResponse,
  ICreateFeedDTO,
  IUpdateFeedDTO,
  IDeleteFeedDTO,
  IRegenerateFeedDTO,
  IExportFeedDTO,
} from '@/models/feeds.model';

export const getFeeds = createAsyncThunk<IGetFeedsResponse, IGetFeedsDTO, { serializedErrorType: IApiError }>(
  `${FEEDS_SLICE_NAME}/getFeeds`,
  async (data) => {
    const response = await FeedsAPI.getFeeds(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createFeed = createAsyncThunk<IGetFeedResponse, ICreateFeedDTO, { serializedErrorType: IApiError }>(
  `${FEEDS_SLICE_NAME}/createFeed`,
  async (data) => {
    const response = await FeedsAPI.createFeed(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const regenerateFeed = createAsyncThunk<
  IGetFeedResponse,
  IRegenerateFeedDTO,
  { serializedErrorType: IApiError }
>(
  `${FEEDS_SLICE_NAME}/regenerateFeed`,
  async (data) => {
    const response = await FeedsAPI.regenerateFeed(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getFeed = createAsyncThunk<IGetFeedResponse, IGetFeedDTO, { serializedErrorType: IApiError }>(
  `${FEEDS_SLICE_NAME}/getFeed`,
  async (data) => {
    const response = await FeedsAPI.getFeed(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getExportFeeds = createAsyncThunk<Blob, IExportFeedDTO, { serializedErrorType: IApiError }>(
  `${FEEDS_SLICE_NAME}/getExportFeeds`,
  async (data) => {
    const response = await FeedsAPI.getExportFeeds(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateFeed = createAsyncThunk<IGetFeedResponse, IUpdateFeedDTO, { serializedErrorType: IApiError }>(
  `${FEEDS_SLICE_NAME}/updateFeed`,
  async (data) => {
    const response = await FeedsAPI.updateFeed(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteFeed = createAsyncThunk<void, IDeleteFeedDTO, { serializedErrorType: IApiError }>(
  `${FEEDS_SLICE_NAME}/deleteFeed`,
  async (data) => {
    const response = await FeedsAPI.deleteFeed(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
